<template>
    <div
        class="page_sheet"
        :class="[{ 'isOverflowHidden': elementsVisible }, isPageLockedForUser ? 'pageLocked' : '']"
        :style="`background-color: #${page.content.pageColor.hex}; border-radius: ${page.content.pageRadius}%; background-image: url(${page.content.backgroundImage.url}); background-size: ${page.content.backgroundImage.backgroundSize}; background-position: ${page.content.backgroundImage.backgroundPosition}; background-repeat: ${page.content.backgroundImage.backgroundRepeat}`"
        id="page_sheet"
        v-on:click.self="clearActiveElements"

    >
        <div
            class="page_sheet-print"
            v-on:click.self="clearActiveElements"
            :id="page.content.id"
        >
            <Element
                v-for="(element) in page.content.elements"
                :key="`${element.id}-key`"
                :el="element"
                :id="element.id"
                :tabindex="page.content.isActive ? 1 : ''"
                @keydown.native.46="deleteElement"
                @keydown.native.27="clearActiveElements"
                :parentId="page.content.id"
                ref="el"
            />
        </div>
        <div ref="page_bleed" class="page_bleed" :style="`border-radius: ${page.content.pageRadius}%`" />
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import Element from '../Element.vue';
    import { vuexHistory } from '../../../store/index';

    export default {
        data() {
            return {
                pagePxWidth: null,
                bleedWidthData: null,
                bleedHeightData: null
            }
        },
        props: ['page'],
        methods: {
            deleteElement() {
                this.$store.dispatch('REMOVE_PAGE_ELEMENT')
            },
            pageSize() {
                if (this.getTemplateFormat.pageWidth > this.getTemplateFormat.pageHeight) {
                    let div = (this.getTemplateFormat.pageHeight + 2 * this.getTemplateFormat.pageBleed) / (this.getTemplateFormat.pageWidth + 2 * this.getTemplateFormat.pageBleed);
                    this.$el.style.width = `100%`;
                    this.$el.style.height = `${div*100}%`;
                    this.$store.dispatch('SAVE_PAGE_SIZE', {
                        width: `100%`,
                        height: `${div*100}%`
                    })
                } else if (this.getTemplateFormat.pageHeight > this.getTemplateFormat.pageWidth) {
                    let div = (this.getTemplateFormat.pageWidth + 2 * this.getTemplateFormat.pageBleed) / (this.getTemplateFormat.pageHeight + 2 * this.getTemplateFormat.pageBleed);
                    this.$el.style.width = `${div*100}%`;
                    this.$el.style.height = `100%`;
                    this.$store.dispatch('SAVE_PAGE_SIZE', {
                        width: `${div*100}%`,
                        height: `100%`
                    })
                } else {
                    this.$el.style.width = `100%`;
                    this.$el.style.height = `100%`;
                    this.$store.dispatch('SAVE_PAGE_SIZE', {
                        width: `100%`,
                        height: `100%`
                    })
                }

                this.$el.children[0].style.height = `100%`;
                this.$el.children[0].style.width = `100%`;

                this.calculateBleed();
            },
            clearActiveElements() {
                this.$store.dispatch('DISABLE_ELEMENTS_ON_PAGE');
            },
            calculateBleed() {
                // bleed width px

                const bleedRatioWidth = this.getTemplateFormat.pageWidth / this.getTemplateFormat.pageBleed;
                
                const x = this.getPageWebSize.px.width / (2 + bleedRatioWidth);

                const bleedWidth = this.getPageWebSize.px.width - 2 * x;

                this.$refs.page_bleed.style.width = `${bleedWidth}px`;

                // bleed height px

                const bleedRatioHeight = this.getTemplateFormat.pageHeight / this.getTemplateFormat.pageBleed;
                
                const y = this.getPageWebSize.px.height / (2 + bleedRatioHeight);

                const bleedHeight = this.getPageWebSize.px.height - 2 * y;

                this.$refs.page_bleed.style.height = `${bleedHeight}px`;
            }
        },
        computed: {
            ...mapState([
                'elementsVisible'
            ]),
            ...mapGetters([
                'getTemplateFormat',
                'getProject',
                'getPageWebSize',
                'getPageSize',
                'getActivePage',
                'getSessionDetails'
            ]),
            isPageLockedForUser() {
                if (this.getSessionDetails.mode === 'user') {
                    return this.page.content.isLocked;
                }
                return false;
            }
        },
        watch: {
            getTemplateFormat: {
                immediate: false,
                deep: true,
                handler() {
                    this.pageSize();
                    const webPageSize = {
                        px: {
                            width: this.$el.offsetWidth,
                            height: this.$el.offsetHeight
                        },
                        mm: {
                            width: this.$el.offsetWidth * 0.084667,
                            height: this.$el.offsetHeight * 0.084667
                        },
                        // mm: {
                        //     width: this.$el.offsetWidth * 0.264583,
                        //     height: this.$el.offsetHeight * 0.264583
                        // },
                        hasValue: true,
                        ratio: (this.getTemplateFormat.pageWidth + 2 * this.getTemplateFormat.pageBleed) / (this.$el.offsetWidth * 0.084667)
                        // ratio: (this.getTemplateFormat.pageWidth + 2 * this.getTemplateFormat.pageBleed) / (this.$el.offsetWidth * 0.264583)
                    }
                    this.$store.dispatch('SAVE_PAGE_WEB_SIZE', webPageSize);

                    this.calculateBleed();
                    this.$el.style.width = this.getPageSize.width;
                    this.$el.style.height = this.getPageSize.height;
                }
            }
        },
        mounted() {
            this.$nextTick(function() {
                if(!this.getPageWebSize.hasValue) {
                    this.pageSize();
                    const webPageSize = {
                        px: {
                            width: this.$el.offsetWidth,
                            height: this.$el.offsetHeight
                        },
                        mm: {
                            width: this.$el.offsetWidth * 0.084667,
                            height: this.$el.offsetHeight * 0.084667
                        },
                        // mm: {
                        //     width: this.$el.offsetWidth * 0.264583,
                        //     height: this.$el.offsetHeight * 0.264583
                        // },
                        hasValue: true,
                        ratio: (this.getTemplateFormat.pageWidth + 2 * this.getTemplateFormat.pageBleed) / (this.$el.offsetWidth * 0.084667)
                        // ratio: (this.getTemplateFormat.pageWidth + 2 * this.getTemplateFormat.pageBleed) / (this.$el.offsetWidth * 0.264583)
                    }
                    this.$store.dispatch('SAVE_PAGE_WEB_SIZE', webPageSize); 
                }

                this.calculateBleed(); 
            })
            this.pageSize();
            
            this.$el.style.width = this.getPageSize.width;
            this.$el.style.height = this.getPageSize.height;
        },
        components: {
            Element
        }
    }
</script>

<style lang="scss">
    @import '@/styles/setup/_variables.scss';

    .page_sheet {
        display: flex;
        box-sizing: border-box;
        margin: auto;
        overflow: hidden;
        position: relative;
    }
    .page_bleed {
        position: absolute;
        margin: auto;
        border: 1px dashed #E4E4E4;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        pointer-events: none;
    }
    .pageLocked {
        pointer-events: none;
        cursor: not-allowed;
    }
    .active .page_sheet.isOverflowHidden {
        overflow: unset!important;
    }
    .page_sheet-print {
        margin: auto;
        position: relative;
    }
</style>